import { useState } from 'react';
import { Button, ButtonProps, Popover, PopoverProps } from 'antd';

import AddCustomerGroupForm from './AddCustomerGroupForm';

import styles from './AddCustomerGroupButton.module.less';
import { CustomerGroupOption } from '../CustomerGroupForm';
import { getCustomerGroups } from 'redux/reducers/clientSlice';
import BaseAlert from 'components/wrappers/BaseAlert';
import { ApiErrorMessage } from 'constants/ErrorMessages';
import { useAppDispatch } from 'hooks/useAppDispatch';

type Props = ButtonProps & {
  customerGroupOptions: CustomerGroupOption[];
  popoverProps?: PopoverProps;
};

export default function AddCustomerGroupButton(props: Props) {
  const { customerGroupOptions, popoverProps, ...restProps } = props;

  const dispatch = useAppDispatch();

  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const handleLoadingChange = (newLoading: boolean) => {
    setIsLoading(newLoading);
  };

  const handleSubmit = async () => {
    const result = await dispatch(getCustomerGroups());

    if (!getCustomerGroups.fulfilled.match(result)) {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }

    setOpen(false);
    setIsLoading(false);
  };

  return (
    <Popover
      trigger="click"
      destroyTooltipOnHide
      open={open}
      overlayClassName={styles.popover}
      onOpenChange={handleOpenChange}
      content={
        <AddCustomerGroupForm
          loading={isLoading}
          customerGroupOptions={customerGroupOptions}
          onLoadingChange={handleLoadingChange}
          onSubmit={handleSubmit}
        />
      }
      {...popoverProps}
    >
      <Button type="primary" loading={isLoading} {...restProps}>
        New
      </Button>
    </Popover>
  );
}
